import { connect } from 'react-redux';
import imageDefault from '../../../assets/images/svg/ic-image-default.svg';
import { formatPrice, showErrorToasts } from '../../../services/helpers/Helper';
import { changeQuantity } from '../../../store/action/cartAction';

const Products = (props) => {
   const { carts, changeQuantity } = props;
   const { cartItems } = carts;
   const totalQuanlity = () => {
      return cartItems ? cartItems.reduce((n, { quantity }) => n + quantity, 0) : 0;
   }

   const handleMinus = (item) => {
      changeQuantity(item.item_key, (item.quantity <= 1 ? 1 : item.quantity - 1));
   }

   const handlePlus = (item) => {
      if (item.product_limit_order_count) {
         if (item.product_limit_order_count <= item.quantity + (item.product_order_quantity ? item.product_order_quantity : 0)) {
            showErrorToasts("Bạn không thể mua quá " + item.product_limit_order_count + " sản phẩm");
            return;
         }
      }
      changeQuantity(item.item_key, item.quantity + 1);
   }
   
   return (
      <div className="list-cart-container">
         <div className="title-container">
            {/* <div className="svg-next-icon icon-title" >
            </div> */}
            <span className="title">
               {formatPrice(totalQuanlity())} sản phẩm chờ bạn xác nhận đặt mua
            </span>
         </div>
         <div className="product-wrapper">
            {cartItems?.map((item, index) => {
               return (
                  <div className="product-item-container" key={index}>
                     <div>
                        <img src={item.product_image ? item.product_image : imageDefault} className="image-product" />
                     </div>
                     <div className="info-product-container">
                        <div className="header-product-container">
                           <div className="title-container">
                              <span title={item.product_name} className="title-product">
                                 {item.product_name}
                              </span>
                           </div>
                           <div className="icon-close">
                              <button type="button"
                                 className="app-btn app-btn-link app-btn-pd-none app-btn-size-small">
                                 <div className="svg-next-icon"></div>
                              </button>
                           </div>
                        </div>
                        <div className="price-container">
                           <span className="price">{formatPrice(item.price)} ₫</span>
                           { item.original_price > item.price &&
                              <span className='price-discount'>{formatPrice(item.original_price)} ₫</span>
                           }
                        </div>
                        <div className="quantity-count-error-container">
                           <div className="count-quantity-container">
                              <div className="pointer-count" onClick={() => handleMinus(item)}>
                                 <span className="plus-symbol">−</span>
                              </div>
                              <span>{formatPrice(item.quantity)}</span>
                              <div className="pointer-count" onClick={() => handlePlus(item)}>
                                 <span className="plus-symbol">+</span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               )
            })}

         </div>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { carts } = state;
   return {
      carts
   };
};

export default connect(mapStateToProps, {
   changeQuantity
})(Products);
